<template>
  <div id="map-container">
    <div v-if="noGPS" id="no-gps-warning">
      <span>{{$t("No GPS signal")}}</span>
    </div>
    <div id="map">
    </div>
  </div>
</template>

<script>
import {
  reactive,
  toRefs,
  watch,
} from "../../plugins/compositionApi";
import GoogleMaps from '../../service/GoogleMapsApi'

export default {
  props: {
    position: Object
  },
  setup (props) {
    const data = reactive({
      map: null,
      marker: null,
      gpsWarningTimeOut: null,
      noGPS: false
    })
    // const emergencyEventMarker = {
    //   path: "M256,16C123.452,16,16,123.452,16,256s107.452,240,240,240c132.549,0,240-107.452,240-240S388.549,16,256,16z M256,444.583  c-23.195,0-41.998-18.803-41.998-41.998s18.803-41.998,41.998-41.998c23.195,0,41.998,18.803,41.998,41.998  S279.196,444.583,256,444.583z M297.747,300.588c0,16.568-13.432,30-30,30h-23.494c-16.568,0-30-13.432-30-30l-25-209.986  c0-16.568,13.432-30,30-30h73.494c16.568,0,30,13.432,30,30L297.747,300.588z",
    //   fillColor: "blue",
    //   fillOpacity: 0.6,
    //   strokeWeight: 0,
    //   rotation: 0,
    //   scale: 2,
    //   anchor: new google.maps.Point(15, 30),
    // }
    GoogleMaps.load().then(() => {
      data.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 0, lng: 0 },
        zoom: 15,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: false,
        disableDoubleClickZoom: false,
        draggableCursor: false,
        draggable: false
      });

      // new google.maps.Marker({
      //   position: {lat: 52.30846804976113, lng: 4.94624506888305},
      //   map: data.map,
      //   icon:emergencyEventMarker,
      // });

      data.marker = new google.maps.Marker({position: new google.maps.LatLng(0, 0), map: data.map});

      data.marker.setMap(data.map);
      
      watch(
        () => props.position,
        (newValue, oldValue) => {
          if (newValue.latitude && newValue.longitude) {
            const pos = new google.maps.LatLng(newValue.latitude, newValue.longitude)
            data.marker.setPosition(pos);
            data.map.panTo(pos);
            clearTimeout(data.gpsWarningTimeOut)
            data.gpsWarningTimeOut = null
            data.noGPS = false
          } else if (!data.gpsWarningTimeOut) {
            data.gpsWarningTimeOut = setTimeout (() => data.noGPS = true, 3000)
          }
        }
      );  
    });

    return { ...toRefs(data) }
  }
}
</script>

<style lang="scss" scoped>
#map-container {
  border-radius: 8px;
  height: 100%;
  position: relative;
}
#map {
  border-radius: 8px;
  height: 100%;
  border-radius: 8px;
}
#no-gps-warning {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: rgba(255, 29, 29, 0.685);
  z-index: 1;
  width: 100%;
  height: 70px;
  position: absolute;
  color: white;
  line-height: 70px;
  text-align: center;
}

</style>
